<template>
  <div>
    <Navigation />
    <div v-if="addNewBrand" class="popUp-overlay"></div>
    <div class="row tableUsers">
      <div v-show="addNewBrand" class="popUp zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="package_name"
                      >Brand Package Name</label
                    >
                    <input
                      id="package_name"
                      v-model="package_name"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="selected_brand">Brand</label>
                    <select
                      v-model="selected_brand"
                      name="selected_brand"
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(brand, index) in brands"
                        v-bind:value="{ id: brand.id, code: brand.code }"
                      >
                        {{ brand.name }}
                      </option>
                    </select>
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="selected_type">Type</label>
                    <select
                      v-model="selected_type"
                      name="selected_type"
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(type, index) in types"
                        v-bind:value="{ id: type.id, code: type.code }"
                      >
                        {{ type.name }}
                      </option>
                    </select>
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="selected_size">Size</label>
                    <select
                      v-model="selected_size"
                      name="selected_size"
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(size, index) in sizes"
                        v-bind:value="{ id: size.id, code: size.code }"
                      >
                        {{ size.name }}
                      </option>
                    </select>
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="greenpoints"
                      >Green Points</label
                    >
                    <input
                      id="greenpoints"
                      v-model="greenpoints"
                      type="number"
                      name="greenpoints"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div v-if="errorMsg" class="row">
                <div class="col-md-12">
                  <div class="error-infobox">{{ errorMsg }}</div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="addBrandPackaging()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="
                      addNewBrand = false;
                      errorMsg = '';
                    "
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="editBrand" class="popUp-overlay"></div>
      <div v-show="editBrand" class="popUp zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_package_name"
                      >Packaging Name</label
                    >
                    <input
                      id="edit_package_name"
                      v-model="edit_package_name"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                      value
                      readonly
                    />
                    <input type="hidden" v-model="edit_package_id" value />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="selected_brand">Brand</label>
                    <!--  <select v-model="edit_selected_brand"  name="edit_selected_brand" class="custom-select custom-select-sm form-control form-control-sm">
                                        <option v-for="(brand, index) in brands" v-bind:value="{ id: brand.id, code: brand.code }" >{{brand.name}}</option>      
                    </select>-->
                    <input
                      v-model="edit_selected_brand"
                      id="edit_selected_brand"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_type">Type</label>
                    <!--   <select  v-model="edit_type"  name="selected_type"  class="custom-select custom-select-sm form-control form-control-sm">
                                        <option v-for="(type, index) in types" v-bind:value="{ id: type.id, code: type.code }">{{type.name}}</option>      
                    </select>-->
                    <input
                      v-model="edit_type"
                      id="edit_type"
                      type="edit_type"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_size">Size</label>
                    <!--   <select v-model="edit_size"  name="selected_size" class="custom-select custom-select-sm form-control form-control-sm">
                                        <option v-for="(size, index) in sizes" v-bind:value="size.code">{{size.name}}</option>      
                    </select>-->
                    <input
                      v-model="edit_size"
                      id="edit_size"
                      type="text"
                      name="edit_size"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="greenpoints"
                      >Green Points</label
                    >
                    <input
                      id="greenpoints"
                      v-model="edit_points"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                      v-on:keyup="errorMsg = ''"
                    />
                  </div>
                </div>
              </div>
              <div v-if="errorMsg" class="row">
                <div class="col-md-12">
                  <div class="error-infobox">{{ errorMsg }}</div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="editBrandPackaging()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="
                      editBrand = false;
                      errorMsg = '';
                    "
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="deleteBrand" class="popUp-overlay"></div>
      <div v-show="deleteBrand" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label for="delete_packaging_id" style="margin-bottom: 0px"
                      >Are you sure you want to delete this Brand?</label
                    >
                    <input
                      type="hidden"
                      v-model="delete_packaging_id"
                      name="delete_packaging_id"
                      value
                    />
                    <label v-if="errorMsg" class="error-infobox">{{
                      errorMsg
                    }}</label>
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <input
                    @click.prevent="confirmDelete()"
                    type="submit"
                    class="btn danger btnDark btn-success btn-send pointer"
                    value="Yes"
                  />
                  <input
                    v-on:click="deleteBrand = false"
                    type="cancel"
                    class="btn btnDark btn-success pointer"
                    value="No"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-4 tableName tableHeading">
                  <a
                    href="#"
                    class="btn btn-round btn-icon btn-sm createNew mt-1"
                    title="Add new packaging"
                    v-on:click="addNew()"
                  >
                    <i class="fas fa-plus"></i>
                  </a>
                  Packagings
                </div>
                <div class="col-sm-12 col-md-5"></div>
                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter mt-3">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-2"
                    >
                      <input
                        class="form-control borderNone form-control-sm mr-3"
                        v-model="search"
                        v-on:keyup="filterResults()"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortResults(1)"
                        >
                          Packaging Name
                        </th>
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortResults(1)"
                        >
                          Code
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                          v-on:click="sortResults(2)"
                        >
                          Brand name
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                          v-on:click="sortResults(3)"
                        >
                          Type of materials
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 200px"
                          aria-label="Age: activate to sort column ascending"
                          v-on:click="sortResults(4)"
                        >
                          Size
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 200px"
                          aria-label="Age: activate to sort column ascending"
                          v-on:click="sortResults(5)"
                        >
                          Green Points
                        </th>
                        <th
                          class="disabled-sorting text-right sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-for="(item, index) in items"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">{{ item.name }}</td>
                        <td>{{ item.code }}</td>
                        <td>{{ item.brand_name }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.size }}</td>
                        <td>{{ item.greenpoints }}</td>
                        <td class="text-right">
                          <div class="actions_on_user">
                            <a
                              href="#"
                              class="btn btn-round btn-edit btn-icon btn-sm edit"
                              v-on:click="edit(item.id)"
                              id="edit"
                            >
                              <i class="far fa-edit"></i>
                            </a>
                            <label class="activity_label" for="edit"
                              >Edit</label
                            >
                          </div>
                          <div class="actions_on_user">
                            <a
                              href="#"
                              class="btn btn-round btn-danger btn-icon btn-sm remove"
                              v-on:click="del(item.id)"
                              id="delete"
                            >
                              <i class="fas fa-times"></i>
                            </a>
                            <label class="activity_label" for="delete"
                              >Delete</label
                            >
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination
                :meta_data="meta_data"
                v-on:next="fetchResults"
              ></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      addNewBrand: false,
      editBrand: false,
      deleteBrand: false,
      errors: [],
      items: [],
      brands: [],
      types: [],
      sizes: [],
      search: null,
      order: null,
      dir: 0,
      sort: null,
      package_name: null,
      selected_size: [],
      selected_brand: [],
      edit_package_id: "",
      edit_selected_brand: "",
      edit_type: "",
      edit_size: "",
      edit_points: "",
      selected_type: [],
      greenpoints: null,
      delete_packaging_id: "",
      errorMsg: "",
      edit_package_name: "",
      edit_package_brand_id: null,
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
    };
  },
  mounted() {
    this.fetchResults(
      this.meta_data.page,
      this.meta_data.perpage,
      this.search,
      this.order,
      this.sort
    );
  },
  methods: {
    addNew() {
      this.$data.addNewBrand = true;
      this.fetchOptions();
      this.package_name = this.selected_brand.id = this.selected_brand.code = null;
      this.selected_type.id = this.selected_type.code = this.greenpoints = this.selected_size.id = this.selected_size.code = null;
    },
    edit(id) {
      this.$data.editBrand = true;
      this.edit_package_name = "";
      axios
        .get(store.state.BASE_URI + "admin/packaging/fetch_packaging", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            id,
          },
        })
        .then((res) => {
          this.fetchOptions();
          this.edit_package_name = res.data.content.name;
          this.edit_selected_brand = res.data.content.brand_name;
          this.edit_size = res.data.content.size;
          this.edit_points = res.data.content.greenpoints;
          this.edit_type = res.data.content.type;
          this.edit_package_id = res.data.content.id;
        });
    },
    del(id) {
      this.delete_packaging_id = this.errorMsg = "";
      this.delete_packaging_id = id;
      this.$data.deleteBrand = true;
    },
    confirmDelete() {
      axios
        .delete(
          store.state.BASE_URI +
            "admin/packaging/item/" +
            this.delete_packaging_id,
          { headers: { Authorization: localStorage.getItem("accessToken") } }
        )
        .then((res) => {
          this.fetchResults(
            this.meta_data.page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
          );
          this.deleteBrand = false;
          this.$toasted
            .show(res.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted
              .show(this.errorMsg, {
                type: "error",
              })
              .goAway(2000);
          }
        });
    },
    fetchResults(
      page = this.meta_data.current_page,
      perpage = this.meta_data.perpage,
      search = this.search,
      order = this.order,
      sort = this.sort,
      total = this.meta_data.total
    ) {
      axios
        .get(store.state.BASE_URI + "admin/packaging/load_packaging", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            total,
          },
        })
        .then((res) => {
          this.items = res.data.content.results;
          var pagination = res.data.content.pagination;
          this.meta_data.last_page = pagination.last_page;
          this.meta_data.current_page = pagination.current_page;
          this.meta_data.prev_page_url = pagination.prev_page_url;
          this.meta_data.perpage = pagination.perpage;
          this.meta_data.search = pagination.search;
          this.meta_data.total = pagination.total;
        });
    },
    filterResults() {
      this.meta_data.current_page = 1;
      this.fetchResults(
        this.meta_data.page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort
      );
    },
    sortResults(order) {
      this.dir++;
      this.order = order;

      if (this.dir % 2 == 0) this.sort = "desc";
      else this.sort = "asc";
      this.fetchResults(
        this.meta_data.page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort
      );
    },
    fetchOptions() {
      axios
        .get(store.state.BASE_URI + "admin/brands/brand_options", {
          headers: { Authorization: localStorage.getItem("accessToken") },
        })
        .then((res) => {
          this.types = res.data.results.types;
          this.brands = res.data.results.brands;
          this.sizes = res.data.results.sizes;
        });
    },
    addBrandPackaging() {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );

      axios
        .post(store.state.BASE_URI + "admin/packaging/create", {
          params: {
            name: this.package_name,
            brand_id: this.selected_brand.id,
            brand_code: this.selected_brand.code,
            type_id: this.selected_type.id,
            type_code: this.selected_type.code,
            greenpoints: this.greenpoints,
            size_id: this.selected_size.id,
            size_code: this.selected_size.code,
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.addNewBrand = false;
          this.fetchResults(
            this.meta_data.page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
          );
          this.errorMsg = "";
          this.$toasted
            .show(response.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            if (this.validateFields()) {
              this.$toasted
                .show(this.errorMsg, {
                  type: "error",
                })
                .goAway(2000);
            }
          }
        });
    },
    editBrandPackaging() {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );
      axios
        .post(store.state.BASE_URI + "admin/packaging/edit", {
          params: {
            id: this.edit_package_id,
            name: this.edit_package_name,
            greenpoints: this.edit_points,
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.editBrand = false;
          this.fetchResults(
            this.meta_data.page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
          );
          this.$toasted
            .show(response.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            console.log(error.response.data.message);
            if (this.validateEditFields()) {
              this.$toasted
                .show(this.errorMsg, {
                  type: "error",
                })
                .goAway(2000);
            }
          }
        });
    },
    validateFields() {
      return !this.package_name ||
        !this.selected_brand ||
        !this.selected_type ||
        !this.selected_size ||
        this.greenpoints <= 0
        ? false
        : true;
    },
    validateEditFields() {
      return this.edit_points <= 0 || this.edit_points == null ? false : true;
    },
  },
};
</script>

<style src="../css/style.css"></style>
